import React from "react";
//material ui
import { useMediaQuery } from "@mui/material";

//components
import CardsBenefitsMobile from "./CardsBenefitsMobile";
import CardBenefitsDesktop from "./CardBenefitsDesktop";

const CardsBenefits = () => {
  const isMobile = useMediaQuery("(max-width:899px)");

  return isMobile ? <CardsBenefitsMobile /> : <CardBenefitsDesktop />;
};

export default CardsBenefits;
